
import "./dashboard.css";

import React, { useState, useEffect } from "react";
// import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
// Bootstrap[component]
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Form, Button } from "react-bootstrap";
// import Badge from 'react-bootstrap/Badge';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import logo from '../assets/Logos/Brewing-solutions-3.png';
import { useNavigate } from "react-router-dom";

function Dashboard() {
     const navigate = useNavigate();
  const [key, setKey] = useState('products');
  const [showproduct, setShowProduct] = useState(false);

  // prodct handlers
  const ProducthandleClose = () => setShowProduct(false);
  const ProducthandleShow = () => {
    resetForm();
    setShowProduct(true);
  }
  // const handelCloseEdit = () => setShowEditClient(false);

  const [clients, setClients] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    name: '',
    description: '',
    location: '',
    logo: null,
    products: [],
  });
  
  useEffect(() => {
    fetchClients();
  }, []);
  
  // Fetch clients
  const fetchClients = async () => {
    try {
      const res = await fetch('https://pints.beer/api/get_clients.php');
      if (!res.ok) {
        throw new Error(`Failed to load: ${res.status} ${res.statusText}`);
      }
      const data = await res.json();
      console.log(data);
      setClients(data);
    } catch (err) {
      toast.error('Failed to fetch clients');
      setClients([]);
    }
  };
  
  // Handle form change
  const handleChange = (e) => {
    if (e.target.name === 'logo') {
      setFormData({ ...formData, logo: e.target.files[0] });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };
  
  // Handle product change
  const handleProductChange = (index, key, value) => {
    const updatedProducts = [...formData.products];
    updatedProducts[index][key] = value;
    setFormData({ ...formData, products: updatedProducts });
  };
  
  // Add new product
  const addProduct = () => {
    setFormData({
      ...formData,
      products: [...formData.products, { name: '', beercolor:'', description: '', bitterness: '',  colorscale: '', alcoholicstrength: '' }],
    });
  };
  
  // Remove product
  const removeProduct = (index) => {
    const updatedProducts = formData.products.filter((_, i) => i !== index);
    setFormData({ ...formData, products: updatedProducts });
  };
  
  // Add or update client
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formDataObj = new FormData();
    formDataObj.append('name', formData.name);
    formDataObj.append('description', formData.description);
    formDataObj.append('location', formData.location);
    if (formData.logo) {
      formDataObj.append('logo', formData.logo);
    }
    formDataObj.append('products', JSON.stringify(formData.products));
  
    try {
      let res;
      if (formData.id) {
        // Update client
        formDataObj.append('id', formData.id);
        res = await fetch('https://pints.beer/api/update_client.php', {
          method: 'POST',
          body: formDataObj,
        });
      } else {
        // Add client
        res = await fetch('https://pints.beer/api/add_client.php', {
          method: 'POST',
          body: formDataObj,
        });
      }
  
      if (!res.ok) {
        throw new Error(`Failed to save: ${res.status} ${res.statusText}`);
      }
  
      toast.success(formData.id ? 'Client updated successfully' : 'Client added successfully');
      fetchClients();
      setShowProduct(false);
      resetForm();
    } catch (err) {
      toast.error('Failed to save client');
    }
  };
  
  // Delete client
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this client?')) {
      try {
        const res = await fetch(`https://pints.beer/api/delete_client.php?id=${id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
        });
  
        if (!res.ok) {
          throw new Error(`Failed to delete: ${res.status} ${res.statusText}`);
        }
  
        const data = await res.json();
        alert(data.message);
        fetchClients(); // Refresh the list after deleting
        toast.success('deleted client successfully');
      } catch (err) {
        console.error('Failed to delete client:', err.message);
        
      }
    }
  };
  
  // Delete product
  const handleDeleteProduct = async (id) => {
    if (window.confirm('Are you sure you want to delete this product?')) {
      try {
        const res = await fetch(`https://pints.beer/api/delete_product.php?id=${id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
        });
  
        if (!res.ok) {
          throw new Error(`Failed to delete product: ${res.status} ${res.statusText}`);
        }
  
        const data = await res.json();
        alert(data.message);
        fetchClients(); // Refresh product list after deletion
        toast.success('deleted product successfully');
      } catch (err) {
        console.error('Failed to delete product:', err.message);
        toast.error('Failed to delete product');
      }
    }
  };
  
  // Edit client
  const handleEdit = (client) => {
    setFormData({
      id: client.id,
      name: client.name,
      description: client.description,
      location: client.location,
      products: client.products,
      logo: null,
    });
    setShowProduct(true);
  };
  
  // Reset form
  const resetForm = () => {
    setFormData({
      id: null,
      name: '',
      description: '',
      location: '',
      logo: null,
      products: [],
    });
  };
  
  // //Logut
  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };
  return (
    <div className="dash-container">
      <Navbar expand="lg" className="bg-body-tertiary">
        <Container className='justify-content-between'>
          <Navbar.Brand href="/"><img src={logo} alt='logo' width="125" height="auto" /></Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
            <Nav>
           
              <Nav.Link class="nav-link contact--button active" onClick={handleLogout}>Logout</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Container className="mt-4">
        <Row className="table-responsive mobile-hide">
          <Button variant="success" className="mt-4 mb-4 float-start rounded-5" onClick={ProducthandleShow}> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-plus-lg" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
          </svg> Add New Products
          </Button>

          <ToastContainer />
          {/* ///////////////////// product Tab */}
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="mb-3"
          >


        

{/* ///////////////////// Client Tab */}
            <Tab eventKey="products" title="Clients">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th width="160">Images</th>
                    <th>Title</th>
                    {/* <th>Beercolor</th> */}
                    <th>Location</th>
                    <th>Description</th>
                   
                    {/* <th>View</th> */}
                    <th>Edit</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>

                  {clients?.map((client) => (
                    <tr key={client.id}>
                      <td>{client.id}</td>
                      <td width="160" className="position-relative">
                        <img className="rounded-pill page-img" height="40" alt={client.name} src={`https://pints.beer/api/${client.logo}`} width="40" />

                      </td>
                      <td className="par-h1 _mh1 fw-semibold">{client.name}</td>
                     
                      <td className="par-h1 _mh5">{client.location}</td>
                      <td className="par-h1 _mh5">{client.description}</td>

                    
                      <td><Button  onClick={() => handleEdit(client)} as="button" variant="success rounded-2"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                      </svg></Button>
                      </td>
                      <td><Button onClick={() => handleDelete(client.id)} as="button" variant="danger rounded-2"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-trash3-fill" viewBox="0 0 16 16">
                        <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                      </svg> </Button>
                      </td>
                    </tr>

                  ))}

                </tbody>
              </Table>
            </Tab>

            <Tab eventKey="events" title="Products">
              {clients?.map((client) => (
                <>
                  <h2 className="mb-3 mt-4 fs-3 fw-semibold">{client.name}</h2>
                  <Table striped bordered hover className="table-events">

                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Product</th>
                        <th>Beercolor</th>
                       
                        <th>Bitterness</th>
                        <th>Colorscale</th>
                        <th>Alcoholic</th>
                        <th>Description</th>
                        {/* <th>View</th> */}
                        {/* <th>Edit</th> */}
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {client.products.map((product) => (
                        <tr>
                          <td className="par-h1 _mh5">{product.id}</td>
                          <td className="par-h1 _mh1 fw-semibold">{product.name}</td>
                          <td className="par-h1 _mh5">{product.beercolor}</td>
                          <td className="par-h1 _mh5">{product.bitterness}</td>
                          <td className="par-h1 _mh5">{product.colorscale}</td>
                          <td className="par-h1 _mh5">{product.alcoholicstrength}</td>
                          <td className="par-h1 _mh5">{product.description}</td>

                         
                          {/* <td><Button  onClick={() => handleEditProduct(product)} as="button" variant="success rounded-2"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                          </svg></Button>
                          </td> */}
                          <td><Button as="button" onClick={() => handleDeleteProduct(product.id)} variant="danger rounded-2"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-trash3-fill" viewBox="0 0 16 16">
                            <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                          </svg> </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>

                  </Table>
                </>

              ))}
            </Tab>

          </Tabs>




{/* // Ctreare new Client & Products  */}

      <Modal show={showproduct} onHide={ProducthandleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
             <h1 className="h1 fs-3 fw-semibold text-black">
                Add Client
             </h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <h6 className="mb-3 fs-3 fw-semibold">Add Client Info</h6>
           
                        
            <Form onSubmit={handleSubmit}>
                <Form.Group as={Col} md="12" className="mb-3">
                   
                    <Form.Control type="text" name="name" value={formData.name} placeholder="Client Name" onChange={handleChange} required />
                </Form.Group>
               
                
                <Form.Group as={Col} md="12" className="mb-3">
                    <Form.Label className='fw-semibold'>Location</Form.Label>
                    <Form.Control type="text" name="location" value={formData.location} placeholder="Location" onChange={handleChange} required/>
                </Form.Group>
                <Form.Group as={Col} md="12" className="mb-3">
                    <Form.Label className='fw-semibold'>Client Logo</Form.Label>
                    <Form.Control type="file" name="logo" accept="image/*" onChange={handleChange} />
                </Form.Group>
                <Form.Group as={Col} md="12" className="mb-3">
                    <Form.Label className='fw-semibold'>Description</Form.Label>
                    <Form.Control as="textarea" name="description" value={formData.description} placeholder="Description" onChange={handleChange} required/>
                </Form.Group>

                <div className="flex flex-col items-center">
                {formData.products.map((product, index) => (
                  <Col key={index} className="factstext">
                     <h6 className="mb-3 fs-3 fw-semibold">{formData.id ? (product.name):'Add Product'}</h6>
                     <Form.Group as={Col} md="12" className="mb-3">
                    <Form.Label className='fw-semibold'>Product Name</Form.Label>
                    <Form.Control type="text" name="name" placeholder="Product Name" value={product.name} onChange={(e) => handleProductChange(index, 'name', e.target.value)} />
                </Form.Group>
               
               
                <Form.Group as={Col} md="12" className="mb-3">
                <Form.Label className='fw-semibold'>{formData.id ? (`Selected BeerColor: ${product.beercolor}`) : "Select BeerColor"}</Form.Label>
                <Form.Select aria-label="Default select example" name="beercolor" value={product.beercolor} onChange={(e) => handleProductChange(index, 'beercolor', e.target.value)} required>
                   <option value="0">Select Your Option</option>
                    <option value="plane">Plane</option>
                    <option value="light">Light</option>
                    <option value="dark">Dark</option>
                    <option value="darker">Darker</option>
                    <option value="darkest">Darkest</option>
                    <option value="pitchdark">Pitch Dark</option>
                  </Form.Select>
                </Form.Group>


                <Form.Group as={Col} md="12" className="mb-3">
                    <Form.Label className='fw-semibold'>Bitterness Level (IBU)</Form.Label>
                    <Form.Control type="text" name="bitterness" placeholder="Bitterness (0-100)" value={product.bitterness} onChange={(e) => handleProductChange(index, 'bitterness', e.target.value)} required/>
                </Form.Group>
                <Form.Group as={Col} md="12" className="mb-3">
                    <Form.Label className='fw-semibold'>Colour Scale (SRM)</Form.Label>
                    <Form.Control type="text" name="colorscale" placeholder="Color Scale" value={product.colorscale} onChange={(e) => handleProductChange(index, 'colorscale', e.target.value)}  required/>
                </Form.Group>
                <Form.Group as={Col} md="12" className="mb-3">
                    <Form.Label className='fw-semibold'>Alcoholic Strength (ABV)</Form.Label>
                    <Form.Control type="text" name="alcoholicstrength" placeholder="Alcoholic Strength (%)" value={product.alcoholicstrength} onChange={(e) => handleProductChange(index, 'alcoholicstrength', e.target.value)} required/>
                </Form.Group>
                <Form.Group as={Col} md="12" className="mb-3">
                    <Form.Label className='fw-semibold'>Description</Form.Label>
                    <Form.Control as="textarea" name="description" placeholder="Description" value={product.description} onChange={(e) => handleProductChange(index, 'description', e.target.value)} required/>
                </Form.Group>
                <Button className='mt-2' onClick={() => removeProduct(index)} variant="danger" size="sm"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eraser-fill" viewBox="0 0 16 16">
  <path d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828zm.66 11.34L3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293z"/>
</svg> Remove</Button>
                  </Col>
                 ))}
                 </div>
                <Col>
                  <Button variant="warning" className="mb-3" type="button" onClick={addProduct}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                  </svg> Add Product</Button>
                </Col>
               <Modal.Footer>
                     <Button type="submit" variant="primary">{formData.id ? 'Update & Submit':'Save & Submit'}</Button>
               </Modal.Footer>
            </Form>
        </Modal.Body>
      </Modal>
        </Row> 
      </Container>
    </div>
  );
}

export default Dashboard;